module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAZ0lEQVR4AWOgD9CoIBIhNHAb1vlmLuTQryFWg0PcrHcfv+kHTFBy7SJKA69xvVPC7I17r207eAOombAGCDp16fHVOy8ZNSuJ0gBUp+Pbr+ndx6JdhUsDuaH05zmxiFQNlEQcsWhQAgBaL5FfDH+zdAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CW.png
// module id = 1118
// module chunks = 0